import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_USAGE_HISTORIES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_USAGE_HISTORY:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_USAGE_HISTORY:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_USAGE_HISTORY:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_USAGE_HISTORY:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
